import type { ColorType } from '@adornis/chemistry/elements/theming/coloring-system.js';
import { html, nothing, type TemplateResult } from 'lit';

export const smallIconButton = (d: {
  icon: string;
  color?: ColorType;
  action?: () => any;
  tooltipText?: string | TemplateResult;
}) => html`
  <tr-button-small icon=${d.icon} .color=${d.color ?? this.colors.secondary.shade(300)} .action=${d.action}>
    ${d.tooltipText ? html` <tr-tooltip placement="top" .text=${d.tooltipText}> </tr-tooltip> ` : nothing}
  </tr-button-small>
`;
